import { Reducer } from 'redux';

import { NetworkGroupSettingsAction } from '../../domains/networkGroupSettings/actions.types';
import { NetworkGroupSettings } from '../types';

const reducer: Reducer<NetworkGroupSettings, NetworkGroupSettingsAction> = (state = null, action) => {
  switch (action.type) {
    case 'NETWORK_GROUP_SETTINGS.FULFILLED':
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
